import * as types from '../../../lib/actionTypes.es6';

// export function downloadDocumentRequest(payload) {
//   return {
//     type: types.DOWNLOAD_DOCUMENT_REQUEST,
//     payload,
//   };
// }

// export function downloadDocumentFailure(error) {
//   return {
//     type: types.DOWNLOAD_DOCUMENT_FAILURE,
//     payload: error,
//   };
// }

// export function downloadDocumentSuccess(response) {
//   return {
//     type: types.DOWNLOAD_DOCUMENT_SUCCESS,
//     payload: response,
//   };
// }

// export function resetDownloadDocumentSuccess(error) {
//   return {
//     type: types.RESET_DOWNLOAD_DOCUMENT_SUCCESS,
//   };
// }

// export function resetDownloadDocumentError(error) {
//   return {
//     type: types.RESET_DOWNLOAD_DOCUMENT_ERROR,
//   };
// }

// export function setDocumentEntity(response) {
//   return {
//     type: types.SET_ENTITY_TO_DOWNLOAD_FOR,
//     payload: response,
//   };
// }

// export function resetDocumentEntity(response) {
//   return {
//     type: types.RESET_ENTITY_TO_DOWNLOAD_FOR,
//   };
// }


// template document actions


export function getEmailTemplateRequest(type) {
  return {
    type: types.GET_EMAIL_TEMPLATES_REQUEST,
    payload: type,
  };
}

export function getEmailTemplatesSuccess(response) {
  return {
    type: types.GET_EMAIL_TEMPLATES_SUCCESS,
    payload: response,
  };
}

export function getEmailTemplatesFailed(error) {
  return {
    type: types.GET_EMAIL_TEMPLATES_FAILURE,
    payload: error,
  };
}

export function resetGetEmailTemplates(error) {
  return {
    type: types.RESET_GET_EMAIL_TEMPLATES,
    payload: error,
  };
}



export function addEmailTemplateRequest(payload) {
  return {
    type: types.ADD_EMAIL_TEMPLATE_REQUEST,
    payload,
  };
}

export function addEmailTemplateSuccess(response) {
  return {
    type: types.ADD_EMAIL_TEMPLATE_SUCCESS,
    payload: response,
  };
}

export function addEmailTemplateFailed(error) {
  return {
    type: types.ADD_EMAIL_TEMPLATE_FAILURE,
    payload: error,
  };
}

export function resetAddEmailTemplateSuccess() {
  return {
    type: types.RESET_ADD_EMAIL_TEMPLATE_SUCCESS,
  };
}

export function resetAddEmailTemplateError() {
  return {
    type: types.RESET_ADD_EMAIL_TEMPLATE_ERROR,
  };
}

export function updateEmailTemplateRequest(payload) {
  return {
    type: types.UPDATE_EMAIL_TEMPLATE_REQUEST,
    payload,
  };
}

export function updateEmailTemplateSuccess(response) {
  return {
    type: types.UPDATE_EMAIL_TEMPLATE_SUCCESS,
    payload: response,
  };
}

export function updateEmailTemplateFailed(error) {
  return {
    type: types.UPDATE_EMAIL_TEMPLATE_FAILURE,
    payload: error,
  };
}

export function resetUpdateEmailTemplateSuccess() {
  return {
    type: types.RESET_UPDATE_EMAIL_TEMPLATE_SUCCESS,
  };
}

export function resetUpdateEmailTemplateError() {
  return {
    type: types.RESET_UPDATE_EMAIL_TEMPLATE_ERROR,
  };
}

export function deleteEmailTemplateRequest(payload) {
  return {
    type: types.DELETE_EMAIL_TEMPLATE_REQUEST,
    payload,
  };
}

export function deleteEmailTemplateSuccess(response) {
  return {
    type: types.DELETE_EMAIL_TEMPLATE_SUCCESS,
    payload: response,
  };
}

export function deleteEmailTemplateFailed(error) {
  return {
    type: types.DELETE_EMAIL_TEMPLATE_FAILURE,
    payload: error,
  };
}

export function resetDeleteEmailTemplateSuccess() {
  return {
    type: types.RESET_DELETE_EMAIL_TEMPLATE_SUCCESS,
  };
}

export function resetDeleteEmailTemplateError() {
  return {
    type: types.RESET_DELETE_EMAIL_TEMPLATE_ERROR,
  };
}
